import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/weixin.jpg'


const _hoisted_1 = { class: "bottom" }
const _hoisted_2 = { class: "bottom-top" }
const _hoisted_3 = { class: "bottom-top-box" }
const _hoisted_4 = { class: "bottom-top-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "联系我们", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "bottom-top-right" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", null, "关注析美艺考")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "bottom-bottom" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Copyright © 西安析美易考教育科技有限公司, All Rights Reserved."),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://beian.miit.gov.cn/#/Integrated/index",
      target: "_blank"
    }, "陕ICP备1801469"),
    /*#__PURE__*/_createTextVNode(" 陕公网完备 61019002001456号 ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            _hoisted_5,
            _createElementVNode("li", null, "地址：" + _toDisplayString(_ctx.cmsDetail.cmsAddress), 1),
            _createElementVNode("li", null, "邮箱：" + _toDisplayString(_ctx.cmsDetail.cmsEmail), 1),
            _createElementVNode("li", null, "电话：" + _toDisplayString(_ctx.cmsDetail.cmsTel), 1)
          ])
        ]),
        _hoisted_6
      ])
    ]),
    _hoisted_7
  ]))
}